module.exports = __webpack_public_path__ + "img/done-posting.042c1ecd.png";